import img1 from "@assets/IMG_8395_1760726502477.jpeg";
import img2 from "@assets/IMG_8392_1760726350392.jpeg";
import img3 from "@assets/IMG_8393_1760726350392.jpeg";
import img4 from "@assets/IMG_8394_1760726350392.jpeg";

export interface BeautyOfTheWeekData {
  name: string;
  age: number;
  hometown: string;
  school: string;
  yearMajor: string;
  tagline: string;
  ctaText: string;
  ctaUrl: string;
  photoUrl: string;
  spreadPhotos: string[];
  weekRange: string;
  date: string;
}

export const currentBeautyOfTheWeek: BeautyOfTheWeekData = {
  name: "Angela Burkett",
  age: 20,
  hometown: "New Orleans, LA",
  school: "Southern University A&M College",
  yearMajor: "Junior, Nursing",
  tagline: "Nursing is my calling - healing people and bringing comfort to families is what drives me every day. Being featured by Black Book is such an honor and representation matters!",
  ctaText: "Follow Angela on Instagram",
  ctaUrl: "https://instagram.com/angelab_nursing",
  photoUrl: img1,
  spreadPhotos: [
    img2,
    img3,
    img4
  ],
  weekRange: "September 21-27, 2025",
  date: "September 2025"
};